<template>
  <form
    class="form-horizontal auth-form"
    @submit.prevent="handleSubmit"
    method="post"
  >
    <div class="form-group">
      <input
        v-model="username"
        name="login[username]"
        type="email"
        class="form-control"
        id="exampleInputEmail1"
      />
    </div>
    <div class="form-group">
      <input
        :type="type"
        v-model="password"
        name="login[password]"
        class="form-control"
      />
    </div>
    <div class="form-terms">
      <div class="custom-control custom-checkbox mr-sm-2">
        <input
          type="checkbox"
          class="custom-control-input"
          id="customControlAutosizing"
        />
        <label class="custom-control-label" for="customControlAutosizing"
          >Remember me</label
        >
        <a href="#" class="btn btn-default forgot-pass">lost your password</a>
      </div>
    </div>
    <div class="form-button">
      <button class="btn btn-primary" type="submit" @click="login">
        Login
      </button>
    </div>
    <div class="form-footer">
      <span>Or Login up with social platforms</span>
      <ul class="social">
        <li>
          <feather
            type="facebook"
            class="icon-facebook"
            fill="#F98085"
            stroke="#F98085"
            size="16px"
          ></feather>
        </li>
        <li>
          <feather
            type="twitter"
            stroke="#F98085"
            size="16px"
            class="icon-twitter"
          ></feather>
        </li>
        <li>
          <feather
            type="instagram"
            stroke="#F98085"
            size="16px"
            class="icon-instagram"
          ></feather>
        </li>
        <li>
          <feather
            type="github"
            stroke="#F98085"
            size="16px"
            class="icon-instagram"
          ></feather>
        </li>
      </ul>
    </div>
  </form>
</template>

<script>
import Userauth from "../../auth/index.js";
import firebase from '@/utils/firestore-shim';
export default {
  components: {},
  data() {
    return {
      type: "password",
      username: "",
      password: "",
      submitted: false
    };
  },
  created() {
    // reset login status for JWT
    this.$store.dispatch("authentication/logout");
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
    },
    login() {
      this.submitted = true;
      // Connexion par e-mail + mot de passe (compte SaaS) ; le serveur
      // accepte aussi le super-admin (mot de passe = ADMIN_PASSWORD).
      firebase
        .auth()
        .signInWithEmailAndPassword(this.username, this.password)
        .then(
            result => {
              Userauth.localLogin(result);
              if (result.user.refreshToken) {
                localStorage.setItem(
                  "user",
                  JSON.stringify(result.user.refreshToken)
                );
              }
              // Charge le profil complet (boutiques, abonnement) AVANT la
              // redirection : le garde de navigation s'appuie sur
              // l'entitlement pour autoriser ou non l'accès à l'admin (un
              // compte sans abonnement actif est renvoyé vers la page
              // Abonnement). L'échec est silencieux (session déjà valide).
              firebase.auth().fetchProfile()
                .then(profile => Userauth.setProfile(profile))
                .catch(() => {})
                .then(() => this.$router.push("/"));
            },
            err => {
              this.$toasted.show("Oops... " + err.message, {
                theme: "bubble",
                position: "bottom-right",
                type: "error",
                duration: 2000
              });
            }
          );
    }
  }
};
</script>